import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestDayInfoService {

  constructor() { }

  actualPage = new BehaviorSubject(1);

  actualPage$ = this.actualPage.asObservable();

  newActualPage(page: number){
      this.actualPage.next(page);
  }

  getActualPage(){
    return this.actualPage.value;
  }
}
